exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header {\n  height: 50px;\n  background: #ce93d8;\n  padding: 0 25px; }\n  .header h1 {\n    display: inline-block;\n    font-size: 18px;\n    float: right; }\n  .header img {\n    float: left;\n    margin: 4px 0; }\n\n.content {\n  margin: 0 25px; }\n  .content div {\n    margin-bottom: 25px; }\n  .content p {\n    margin: 30px; }\n  .content a {\n    cursor: pointer;\n    color: #9c64a6;\n    padding: 15px;\n    border: 1px #ffc4ff solid; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/src/app/app.component.sass
// module id = ../../../../../src/app/app.component.sass
// module chunks = 1